module.exports = __webpack_public_path__ + "static/media/arrow-back.a294962d.svg";